// extracted by mini-css-extract-plugin
export default {"main":"styles_main__NHez3","container":"styles_container__RsxrF"};